module.exports = __webpack_public_path__ + "img/img3.c88deddd.jpg";